<template>
  <div class="vacancy-actual">
    <div class="vacancy-actual__name">{{ $tVacancy('Left') }}</div>
    <div v-if="typeof vacancy[1].quantity === 'number'"
         class="vacancy-actual__value">
      {{ vacancy[1].quantity }}
      {{ $tVacancy('places', vacancy[1].quantity) }}
    </div>
    <div v-else
         class="vacancy-actual__value">
      {{ '-' }}
      {{ $tVacancy('places', 0) }}
    </div>
    <template v-if="!isDisabled">
      <div class="vacancy-actual__separator"></div>
      <div class="vacancy-actual__name">{{ $tVacancy('Actual for') }}</div>
      <VacancyActualTimer v-if="vacancy[1].relevant"
                          :endTime="vacancy[1].relevant"
                          class="vacancy-actual__value"/>
    </template>
  </div>
</template>

<script>
  import VacancyActualTimer from './VacancyActualTimer'
  import parseDate from '@/helpers/parseDate'

  export default {
    name: 'VacancyActual',
    components: {
      VacancyActualTimer
    },
    props: ['vacancy'],
    data() {
      return {}
    },
    methods: {
      isDisabled() {
        if (!this.vacancy[1].relevant) return true // ?
        if (!this.vacancy[1].quantity) return true

        const relevantDate = parseDate(this.vacancy[1].relevant)
        return new Date() > relevantDate //ok
      },
    }
  }
</script>

<style lang="less">

</style>
